module.exports = __webpack_public_path__ + "media/night/356-9f49799b.svg";